'use strict';

const _ = require('lodash');
const validator = require('../modelValidator');

class BaseModel {
  constructor(schema) {
    this._schema = schema;
    this._errors = null;
  }

  get schema() {
    return _.cloneDeep(this._schema);
  }

/**
 * Validates all the properties of the model against its schema and populates the errors array.
 * @return {[null]} [No return value]
 */
  validate(schema) {
    this._errors = validator.validate(this, schema || this.schema);
  }

/**
 * Validates a single property against the internal schema or one provided.
 * @param  {[string]} prop             [Property name]
 * @param  {[object]} validationSchema [Validation schema]
 * @return {[Array]}                  [Array of validation errors]
 */
  validateField(prop, validationSchema) {
    const schema = validationSchema || _.pick(this.schema, [prop]);
    return validator.validate(this, schema);
  }

/**
 * Returns the list of validation errors encountered last time validate() was run.
 * @return {[Array]} [Array of validation errors]
 */
  validationErrors() {
    return this._errors.length === 0 ? null : this._errors;
  }

/**
 * Returns the model without the _schema and _errors
 */
  get strippedModel() {
    const model = _.cloneDeep(this);
    delete model._schema;
    delete model._errors;
    return model;
  }
}

module.exports = BaseModel;



// WEBPACK FOOTER //
// ./shared/models/baseModel.js